import { forwardRef } from 'react';
import QRcard, { IQrCard } from '../QRcard/QRcard';
import './HiddenQRList.scss';

interface IHiddenQRList {
  qrList: IQrCard[];
}

const HiddenQRList = forwardRef<HTMLDivElement, IHiddenQRList>(({ qrList }, ref) => {
  return (
    <div ref={ref} className="hiddenQRList">
      {qrList.map((qrData, index) => (
        <div 
          key={`qr-${qrData.qrData.productId}-${qrData.qrData.serial}-${index}`} 
          className="qrItem"
        >
          <QRcard qrData={qrData.qrData} qrCode={qrData.qrCode} />
        </div>
      ))}
    </div>
  );
});

HiddenQRList.displayName = 'HiddenQRList';

export default HiddenQRList;
